"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTable = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const bitcoincom_pkg_theme_1 = require("@bitcoin-portal/bitcoincom-pkg-theme");
exports.StyledTable = styled_components_1.default.div `
  ${({ theme, columns = 3 }) => (0, styled_components_1.css) `
  display: table;
  width: 100%;
  box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  border-radius: 24px;

    & > div {
      touch-action: manipulation;
      transition: all 200ms ease-out;
      display: grid;
      align-items: center;
      padding: ${theme.spacing.unit}px ${theme.spacing.unit * 2}px;
      background-color: ${bitcoincom_pkg_theme_1.colors.solid.bgWhite};
      min-height: 40px;
      grid-template-columns: repeat(${columns}, 1fr);
      border-bottom: 1px solid rgb(239, 239, 239);

      &:hover {
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
        transform: scale(1, 1);
      }
    }

    & > div:last-child {
      border-radius: 0 0 24px 24px;
    }

    & > div:first-child {
      border-radius: 24px 24px 0 0;
      color: ${bitcoincom_pkg_theme_1.colors.solid.textThree};
      font-weight: 400 !important;
    }
  `}
`;
exports.default = {};
//# sourceMappingURL=styled.js.map